var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUganda = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#uganda_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "uganda_svg__b",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.001 0h31.997v24H.001z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#uganda_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFE700",
  fillRule: "evenodd",
  d: "M-2 16.003h36V20H-2v-3.998Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000001",
  fillRule: "evenodd",
  d: "M-2 12h36v3.998H-2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE3908",
  fillRule: "evenodd",
  d: "M-2 8.001h36V12H-2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE700",
  fillRule: "evenodd",
  d: "M-2 4.003h36V8H-2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000001",
  fillRule: "evenodd",
  d: "M-2 0h36v3.998H-2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFDFF",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.117,
  d: "M19.736 12a3.736 3.736 0 1 1-7.472 0 3.736 3.736 0 0 1 7.472 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE3108",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.117,
  d: "m15.344 9.136-.244-.445c.094-.094.248-.169.502-.169l-.029.492z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE700",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.117,
  d: "m15.578 9.014.033-.492s.502-.028.773.3l-.267.384z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE3108",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.117,
  d: "m16.122 9.202.248-.385c.165.174.235.296.258.483.005.005-.389.099-.389.094z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.105,
  d: "M15.466 15.52s.464-.53 1.364-.417c-.136-.22-.577-.192-.577-.192s-.131-1.031-.028-1.087.562.004.562.004c.057 0 .16-.159.075-.262-.08-.103-.318-.492-.22-.572.099-.075.628.047.628.047l-1.5-1.922s-.154-.727.155-1.078c.37-.305.328-.638.319-.633-.052-.337-.563-.577-.91-.267-.201.244-.065.431-.065.431s-.54.145-.558.24c-.024.093.604-.015.604-.015l-.06.427s-1.22 1.106-.282 2.062l.028-.037s.329.403.67.492c.329.328.296.281.296.281s.061.52 0 .623c-.08-.023-.905-.056-1.027-.009-.112.038-.534.014-.43.708l.154-.352s-.014.249.089.338c-.019-.263.098-.44.098-.44s.02.29.085.327c.065.047.065-.468.422-.421.347.042.604.028.604.028s.118 1.003.08 1.097c-.253-.061-.862.023-.9.178.356-.024.52.018.52.018s-.286.258-.197.403Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9CA69C",
  fillRule: "evenodd",
  stroke: "#9CA69C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.105,
  d: "M15.606 10.069s-.886.975-.502 1.72c.02-.103.01-.169.024-.164-.024-.014.108.089.098.07 0-.056-.037-.173-.037-.173l.117.033-.07-.132.173.02s-.06-.16-.042-.16l.14.01c-.252-.45-.014-.826.099-1.229z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9CA69C",
  fillRule: "evenodd",
  stroke: "#9CA69C",
  strokeWidth: 0.117,
  d: "M15.915 9.23s.047.337-.14.43c-.024.024-.14.062-.122.132.019.094.07.075.14.056.193-.033.418-.44.122-.619Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.587 9.516a.07.07 0 1 1-.14 0 .07.07 0 0 1 .14 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE3108",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.117,
  d: "M15.302 9.797c-.047.042-.291.295-.047.389.248-.066.178-.113.234-.169 0-.117-.122-.145-.188-.215v-.005Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9CA69C",
  fillRule: "evenodd",
  stroke: "#9CA69C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.105,
  d: "M15.84 12.21c-.014.057-.07.263.005.423.216-.094.314-.066.385-.019a1.7 1.7 0 0 1-.39-.403Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.105,
  d: "m16.206 13.177.01.478s.168.028.243 0 0-.328-.253-.478",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9CA69C",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.117,
  d: "M17.406 13.237s-.304-.74-1.087-.928c-.783-.187-.68-1.022-.62-1.073.038-.07.062-.183.287-.075s1.265.628 1.415.656.02 1.44.01 1.42z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE3108",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.105,
  d: "M16.666 12.305c-.014.01 1.045.628.726 1.158.3-.202.207-.549.207-.549s.243.642-.357.956c.066.057.108.047.108.047l-.103.099s-.047.08.356-.117c-.108.089-.117.154-.117.154s.028.085.29-.145c-.21.23-.257.347-.257.342.576-.047 1.828-1.922-.394-2.47l.099.103z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.105,
  d: "M16.713 12.122c.14.103.192.14.21.187-.13-.028-.248-.018-.248-.018s-.286-.272-.337-.296c-.038 0-.263-.14-.263-.14-.108-.057-.21-.436.197-.329q.235.123.483.216l.501.16.291.323s-.516-.253-.581-.258c.14.113.22.272.22.272-.164-.047-.305-.094-.473-.117",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.105,
  d: "M14.706 9.839s.492-.122.553-.103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DE3908",
  fillRule: "evenodd",
  d: "M-2 20.002h36V24H-2z",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uganda_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
})))));
export default SvgUganda;